export const doorTypeIds = [
	'hinged_door',
	'cavity_door',
	'bifold_door',
	'internal_sliding_door',
	'external_sliding_door',
	'barn_door',
	'garage_door',
	'double_hinged_door',
] as const;

export const pageTypeIds = [
	'frame_full',
	'overhang_roof_edge',
	'verge_roof_edge',
	'openings',
	'roof_plan_area',
	'elevation_area',
	'floor_plan_area',
	'frontal_verge',
	'perspective',
	'truss',
	'window_schedule',
	'door_schedule',
	'window_drawing',
	'door_drawing',
	'detail_area',
	'floor_plan_option_area',
	'section_area',
	'site_plan_area',
	'window_door_schedule_area',
	'other_plan_area',
	'roof_plan_option_area',
	'elevation_option_area',
	'option_area',
];

export const ids = [
	'hinged_door',
	'cavity_door',
	'bifold_door',
	'internal_sliding_door',
	'external_sliding_door',
	'frame_opening',
	'frame_full',
	'overhang_roof_edge',
	'verge_roof_edge',
	'openings',
	'roof_plan_area',
	'elevation_area',
	'floor_plan_area',
	'frontal_verge',
	'perspective',
	'truss',
	'window_schedule',
	'door_schedule',
	'window_drawing',
	'door_drawing',
	'detail_area',
	'floor_plan_option_area',
	'section_area',
	'site_plan_area',
	'window_door_schedule_area',
	'other_plan_area',
	'roof_plan_option_area',
	'elevation_option_area',
	'option_area',
] as const;
